<template>
    <section>
        <el-dialog
            :visible="dialogVisible"
            custom-class="modal-select-application-type py-5"
            center
            @close="$bus.$emit('toggle-application-journey', false)"
            :show-close="false"
        >
            <div slot="title">
                <h2>Select Application Type</h2>
            </div>

            <div class="w-100 py-3">
                <!-- <span>This is a message</span> -->
                <el-row type="flex" justify="space-around" class="flex-wrap justify-content-around">
                    <el-col v-for="(e, i) in applicationTypes" :key="i" :span="24" :lg="6" :xl="6" :offset="0"
                            :class="['p-2']">
                        <div @click="selectCard(i)">
                            <el-card
                                :class="['application-card', { selected: e.selected }]"
                                :body-style="{ padding: '0px' }"
                                shadow="hover"
                                style="max-width: 285px; text-align: center; margin: 0 auto"
                                v-show="e.visible"
                            >
                                <inline-svg :src="e.image" ref="svgObject" class="svgObject" height="200px"
                                            fill="black"></inline-svg>

                                <div style="padding: 0 14px 14px; margin-top: -5px">
                                    <span style="color: #5f6b75">{{ e.name }}</span>
                                </div>
                            </el-card>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <span slot="footer" class="dialog-footer">
				<el-button @click="$bus.$emit('toggle-application-journey', false)">Cancel</el-button>
			</span>
        </el-dialog>

        <x-modal
            width="600"
            :visible="showDefaults"
            v-if="applicationType"
            :show-close="false"
            okText="Proceed with options"
            @ok="createApplication"
            @cancel="cancelCreate"
            @close="cancelCreate"
        >
            <div slot="title">Create {{ applicationType }} Application</div>

            <el-form ref="createAppForm" label-width="300px" label-position="right" :model="selectedApplicationOptions" :rules="createAppFormRules" class="w-100">

                <el-form-item label="Lead Source" name="source_id" prop="source_id">
                    <el-select v-model="selectedApplicationOptions.source_id" value-key="value"
                    filterable
                               placeholder="Lead Source">
                               <el-option v-for="item in options.sources" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="No. Applicants">
                    <el-select v-model="selectedApplicationOptions.no_of_applicants" placeholder="No of Applicants">
                        <el-option v-for="i in 5" :key="i" :label="i" :value="i"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Seller Type">
                    <el-select v-model="selectedApplicationOptions.seller_type_id" value-key="value"
                               placeholder="Seller Type">
                        <el-option
                            v-for="option in options.sellerTypes"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Asset Type">
                    <el-select v-model="selectedApplicationOptions.asset_type_id" value-key="value"
                               placeholder="Asset Type">
                        <el-option
                            v-for="option in options.assetTypes"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Payment Type">
                    <el-select v-model="selectedApplicationOptions.payment_type" value-key="value"
                               placeholder="Payment Type">
                        <el-option
                            v-for="option in options.paymentTypes"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Preferred Repayment Frequency">
                    <el-select
                        v-model="selectedApplicationOptions.preferred_repayment_frequency"
                        value-key="value"
                        placeholder="Preferred Repayment Frequency"
                    >
                        <el-option
                            v-for="option in options.preferredRepaymentFrequency"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Preferred Repayment Term">
                    <el-select
                        v-model="selectedApplicationOptions.preferred_repayment_term"
                        value-key="value"
                        placeholder="Preferred Repayment Term"
                    >
                        <el-option
                            v-for="option in options.preferredRepaymentTerm"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Save options as my defaults">
                    <el-checkbox v-model="selectedApplicationOptions.set_as_default">Set as default</el-checkbox>
                </el-form-item>
            </el-form>
        </x-modal>
    </section>
</template>

<script>
import {mapState, mapGetters} from "vuex"
const img = (src) => {
    return src
}

export default {
    name: "SelectApplicationType",
    props: {
        openModal: Boolean,
    },
    data() {
        return {
            createAppFormRules: {
                source_id: [{ required: Ambition.getGlobal("tenant").leadSourceRestrict, message: "Lead source is Required" }],
            },
            dialogVisible: false,
            showDefaults: false,
            insuranceDeal: {
                disable: false,
                name: ''
            },
            applicationTypes: [
                {name: "Commercial", image: img("/cj-commercial.svg"), visible: true},
                {name: "Consumer", image: img("/cj-consumer.svg"), visible: true},
                {name: "Insurance Only", image: img("/cj-insurance-only.svg"), visible: true},
            ],
            applicationType: null,
            applicationOptions: {
                Consumer: {
                    lead_source_id: '',
                    no_of_applicants: 1,
                    seller_type_id: 1, // Dealer
                    asset_type_id: 1, // Car
                    application_type_id: 1, // Consumer
                    loan_type_id: 1, // Consumer
                    payment_type: 0, // Arrears
                    preferred_repayment_frequency: "Weekly",
                    preferred_repayment_term: 60, // 5 years
                },
                Commercial: {
                    lead_source_id: '',
                    no_of_applicants: 1,
                    seller_type_id: 1, // Dealer
                    asset_type_id: 1, // Car
                    application_type_id: 2, // Commercial
                    loan_type_id: 2, // Chattel Morgage
                    payment_type: 0, // Arrears
                    preferred_repayment_frequency: "Weekly",
                    preferred_repayment_term: 60, // 5 years
                },
            },
            selectedApplicationOptions: {},
        }
    },
    watch: {
        openModal(newVal, oldVal) {
            this.dialogVisible = newVal
        },
    },
    computed: {
        ...mapState({
            options: "options",
        }),
        ...mapGetters({
            user: "user/user",
        })
    },
    mounted() {
        window.SVG = this.$svg
        this.getInsuranceDealEnabled()
    },
    updated() {
    },
    activated() {
    },
    methods: {
        getInsuranceDealEnabled() {
            const tenant_id = Ambition.getGlobal("tenant.tenantId")

            axios
                .get(`/api/insurance-enabled`)
                .then((res) => {
                    this.applicationTypes.map((applicationType, i) => {
                        if (applicationType.name == "Insurance Only") {
                            applicationType.visible = res.data.value == 0 ? false : true
                        }
                    })

                    this.insuranceDeal.disable = res.data.value == 0 ? true : false
                    this.insuranceDeal.name = res.data.key
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        cancelCreate() {
            this.applicationTypes.map((e) => {
                Object.assign(e, {selected: false})
            })
            this.showDefaults = false
            this.applicationType = null
        },
        selectCard(index) {
            this.$bus.$emit('load::options')

            this.applicationTypes = this.applicationTypes.map((e, i) => {
                if (i === index && e.name == "Insurance Only") {
                    this.createInsuranceApplication()
                    return e
                } else if (i === index) {
                    this.applicationType = e.name
                    if (_.get(this.user, `user_settings.default_new_app_settings.${e.name}`)) {
                        this.selectedApplicationOptions = Object.assign({}, _.get(this.user, `user_settings.default_new_app_settings.${e.name}`));
                    } else {
                        this.selectedApplicationOptions = Object.assign({}, this.applicationOptions[e.name])
                    }
                    this.showDefaults = true
                }
                return Object.assign(e, {selected: i === index})
            })
        },
        setDefaults() {
        },
        createApplication() {
            if (Ambition.getGlobal("tenant").leadSourceRestrict) {
                this.$refs["createAppForm"].validate((valid) => {
                    if (valid) {
                        this.$bus.$emit("create-opp-remote", this.selectedApplicationOptions)
                        this.showDefaults = false
                        this.applicationType = null
                        this.$bus.$emit("toggle-application-journey", false)
                    } else {
                        return false
                    }
                })
            } else {
                this.$bus.$emit("create-opp-remote", this.selectedApplicationOptions)
                this.showDefaults = false
                this.applicationType = null
                this.$bus.$emit("toggle-application-journey", false)
            }
        },

        createInsuranceApplication() {
            this.$bus.$emit("create-insurance-deals-remote", {})
            this.$bus.$emit("toggle-application-journey", false)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@assets/sass/backend/_core-variables.scss";
// $color: #2493ef;
$color: $color-ambition;

.btn-create {
    background-color: $color !important;
    border-color: $color !important;
}

.application-card {
    border: 2px solid #ebeef5;

    &:hover,
    &.selected {
        cursor: pointer;
        border-color: $color;
    }

    object {
        pointer-events: none;
    }
}
</style>

<style lang="scss">
@import "@assets/sass/backend/_core-variables.scss";

$color: $color-ambition;
$color2: #72c149;
.modal-select-application-type {
    $body-size: 60%;
    $header-footer-size: calc((100% - $body-size) / 2);

    > div {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .el-dialog__header {
        height: $header-footer-size;
    }

    .el-dialog__body {
        height: $body-size;
        @media (max-width: 992px) {
            height: auto;
        }
    }

    .el-dialog__footer {
        height: $header-footer-size;
    }

    .application-card {
        circle {
            transition: fill 0.3s linear;
            fill: rgba($color, 1) !important;
            stroke: darken($color, 5%) !important;
        }

        path {
            stroke: #ffffff !important;
        }

        &:hover,
        &.selected {
            cursor: pointer !important;

            circle {
                fill: rgba($color2, 1) !important;
                stroke: darken($color2, 5%) !important;
            }

            path {
                stroke: #ffffff !important;
            }
        }
    }
}
</style>
